import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CustomLayoutComponent } from './custom-layout/custom-layout.component';
import { VexRoutes } from '../@vex/interfaces/vex-route.interface';
import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';
import { AuthGuard } from 'src/shared/guard/auth.guard';
import { LoginGuard } from 'src/shared/guard/login.guard';
import { PermissionGuard } from 'src/shared/guard/permission.guard';
import { ngxPermissionsGuard } from 'ngx-permissions';

const routes: VexRoutes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },

  {
    path: 'login',
    loadChildren: () => import('./pages/pages/auth/login/login.module').then(m => m.LoginModule),
    canActivate: [LoginGuard]

  },
  {
    path: 'register',
    loadChildren: () => import('./pages/pages/auth/register/register.module').then(m => m.RegisterModule),
  },
  {
    path: 'forgot-password/:id',
    loadChildren: () => import('./pages/pages/auth/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
  },

  {
    path: '',
    component: CustomLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboards/analytics',
        redirectTo: '/',
        pathMatch: 'full'
      },
      {
        path: 'question-bank/questions',
        loadChildren: () => import('./pages/question-bank/questions/questions.module').then(m => m.QuestionsModule),
      },
      {
        path: '',
        loadChildren: () => import('./pages/dashboards/dashboard-analytics/dashboard-analytics.module').then(m => m.DashboardAnalyticsModule),
      },
      {
        path: 'apps',
        children: [
          
          {
            path: 'aio-table',
            loadChildren: () => import('./pages/apps/aio-table/aio-table.module').then(m => m.AioTableModule),
          },

          
        ]
      },
      {
        path: 'game-managmant',
        data: {
        permission: 'game-managmant'
        },
        canActivate: [PermissionGuard],
        children: [
          {
            path: 'week',
            loadChildren: () => import('./pages/game-managmant/week/week.module').then(m => m.WeekModule),
            canLoad: [ngxPermissionsGuard],
          },
          {
            path: 'room',
            loadChildren: () => import('./pages/game-managmant/room/room.module').then(m => m.RoomModule),
            canLoad: [ngxPermissionsGuard],
          },
           {
            path: 'game-algoritm',
            loadChildren: () => import('./pages/game-managmant/game-algoritm/game-algoritm.module').then(m => m.GameAlgoritmModule),
            canLoad: [ngxPermissionsGuard],
          },
        ]
      },
      {
        path: 'system-managmant',
         data: {
        permission: 'system-managmant'
        },
        canActivate: [PermissionGuard],
        children: [
          {
            path: 'help',
            loadChildren: () => import('./pages/system-managmant/help/help.module').then(m => m.HelpModule),
            canLoad: [ngxPermissionsGuard],

          },
          {
            path: 'avatar',
            loadChildren: () => import('./pages/system-managmant/avatar/avatar.module').then(m => m.AvatarModule),
            canLoad: [ngxPermissionsGuard],

          },
          {
            path: 'role',
            loadChildren: () => import('./pages/system-managmant/role/role.module').then(m => m.RoleModule),
            canLoad: [ngxPermissionsGuard],
          },
          {
            path: 'base-tables',
            loadChildren: () => import('./pages/system-managmant/base-tables/base-tables.module').then(m => m.BaseTablesModule),
            canLoad: [ngxPermissionsGuard],
          },
          
        ]
      },
      {
        path: 'user-managmant',
        data: {
        permission: 'user-management'
        },
        canActivate: [PermissionGuard],
        children: [
          {
            path: 'users',
            loadChildren: () => import('./pages/user-managmant/users/users.module').then(m => m.UsersModule),
            canLoad: [ngxPermissionsGuard],
          },
          {
            path: 'users-role/:id',
            loadChildren: () => import('./pages/user-managmant/users-role/users-role.module').then(m => m.UsersRoleModule),
            canLoad: [ngxPermissionsGuard],
          },
          {
            path: 'users-history/:id',
            loadChildren: () => import('./pages/user-managmant/users-history/users-history.module').then(m => m.UsersHistoryModule),
            canLoad: [ngxPermissionsGuard],
          },
        ]
      },
      {
        path: 'pages',
        children: [
         
          {
            path: 'error-404',
            loadChildren: () => import('./pages/pages/errors/error-404/error-404.module').then(m => m.Error404Module)
          },
          {
            path: 'error-500',
            loadChildren: () => import('./pages/pages/errors/error-500/error-500.module').then(m => m.Error500Module)
          }
        ]
      },


      {
        path: '**',
        loadChildren: () => import('./pages/pages/errors/error-404/error-404.module').then(m => m.Error404Module)
      }
    ]
  }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        preloadingStrategy: QuicklinkStrategy,
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        useHash:true
    })],
    exports: [RouterModule, QuicklinkModule]
})
export class AppRoutingModule {
}
